class SearchForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()
    this.listeners.add(this, 'submit', this.handleFormSubmit)
  }

  handleFormSubmit (e) {
    if (!this.redirectsExist) {
      return
    }

    e.preventDefault()

    const searchTerm = this.getSearchTerm()
    if (!searchTerm) return

    const redirectUrl = this.findRedirectUrl(searchTerm)
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      this.submit()
    }
  }

  /**
   * Retrieves the search term from the input field
   * @returns {string|null}
   */
  getSearchTerm () {
    return this.input?.value?.toLowerCase().trim() || null
  }

  /**
   * Finds the redirect URL for a given search term
   * @param {string} searchTerm
   * @returns {string|null}
   */
  findRedirectUrl (searchTerm) {
    return (
      window.theme.urlRedirects.find((object) =>
        object.keywords.some(
          (keyword) => keyword.trim().toLowerCase() === searchTerm,
        ),
      )?.url || null
    )
  }

  /**
   * Checks if search redirects exist
   * @returns {boolean}
   */
  get redirectsExist () {
    return window.theme.urlRedirects && window.theme.urlRedirects.length > 0
  }

  /**
   * @returns {HTMLElement|null}
   */
  get input () {
    return this.querySelector('input[type="search"]')
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm, { extends: 'form' })
}
